module.exports = __webpack_public_path__ + "static/snow_removal-4785184ecd3044e64e9605b3098f8b13.jpg";